const translation = {
  nav_home: "Home",
  nav_contracts: "Contracts",
  nav_calculator: "Calculator",
  nav_analysts: "Analysts",
  nav_benefits: "Benefits",
  nav_about: "About",
  nav_contact: "Contact",

  hero_badge: "URGENT OPPORTUNITY",
  hero_title1: "THE IRAN CRISIS",
  hero_title2: "YOUR CHANCE",
  hero_title3: "FOR PROFIT",
  hero_subtitle: "20% of world oil is blocked. Brent prices are soaring. Act now.",
  hero_cta1: "VIEW CONTRACTS",
  hero_cta2: "Learn more",

  contracts_title: "CHOOSE YOUR CONTRACT",
  contracts_subtitle: "Three investment levels with guaranteed returns",
  contract_basic: "BASIC",
  contract_popular: "MOST POPULAR",
  contract_pro: "PROFESSIONAL",
  contract_investment: "Investment",
  contract_profit: "YOUR PROFIT",
  contract_total: "TOTAL YOU RECEIVE",
  contract_yield: "YIELD",
  contract_start: "START",
  contract_choose: "CHOOSE NOW",
  contract_maximize: "MAXIMIZE",
  contract_disclaimer: "* Returns are based on current market conditions and historical data. Investments carry risk.",

  calc_title: "EARNINGS CALCULATOR",
  calc_subtitle: "See how much you can earn with each contract",
  calc_investment: "Your investment:",
  calc_yield: "Yield:",
  calc_profit: "Your profit:",
  calc_total: "Total you receive:",
  calc_basic_label: "Basic level",
  calc_popular_label: "Popular choice",
  calc_max_label: "Maximum profit",
  calc_double: "You double your money!",
  calc_2_5: "You get 2.5x more!",
  calc_3x: "You get over 3x more!",
  calc_best: "BEST OFFER",
  calc_cta_title: "The more you invest, the more you earn!",
  calc_cta_sub: "Our contracts are designed to maximize your profit in the current crisis",
  calc_cta_btn: "START EARNING",

  analysts_badge: "OUR TEAM",
  analysts_title: "Experts with",
  analysts_title_accent: "exclusive access",
  analysts_subtitle: "These specialists provide you access to the best oil contracts and guide you toward maximum profit.",
  analyst_contact: "CONTACT",

  analyst1_name: "Nikolay Iliev",
  analyst1_role: "Chief Financial Analyst",
  analyst1_desc: "Nikolay is a leading expert in oil investments with over 15 years of experience. Specializes in geopolitical risk analysis and its impact on crude oil prices.",
  analyst1_exp: "15+ years experience",
  analyst1_clients: "300+ clients",

  analyst2_name: "Dimitar Stoyanov",
  analyst2_role: "Senior Oil Markets Analyst",
  analyst2_desc: "Dimitar is a specialist in technical analysis of oil markets. Develops strategies to maximize returns in volatile market conditions.",
  analyst2_exp: "12+ years experience",
  analyst2_clients: "250+ clients",

  analyst3_name: "Ivan Stoyanov",
  analyst3_role: "Energy Markets Analyst",
  analyst3_desc: "Ivan Stoyanov focuses on global energy market analysis. Specializes in identifying investment opportunities during crisis situations.",
  analyst3_exp: "10+ years experience",
  analyst3_clients: "200+ clients",

  analyst4_name: "Miglena Staneva",
  analyst4_role: "Financial Consultant",
  analyst4_desc: "Miglena is a certified financial consultant with extensive experience in investment portfolio management. Provides personalized strategies for each client.",
  analyst4_exp: "8+ years experience",
  analyst4_clients: "180+ clients",

  analyst5_name: "Nicolas Stanev",
  analyst5_role: "Commodities Analyst",
  analyst5_desc: "Nicolas Stanev is a specialist in commodity market analysis with a focus on oil and natural gas. Develops precise price movement forecasts.",
  analyst5_exp: "11+ years experience",
  analyst5_clients: "220+ clients",

  analyst6_name: "Stefan Minchev",
  analyst6_role: "Investment Strategist",
  analyst6_desc: "Stefan Minchev is an experienced investment strategist specializing in the oil sector. Helps clients achieve maximum returns through optimized investment strategies.",
  analyst6_exp: "9+ years experience",
  analyst6_clients: "190+ clients",

  benefits_title: "WHY CHOOSE US",
  benefits_subtitle: "Advantages of investing in Brent oil contracts",
  benefit1_title: "High Returns",
  benefit1_desc: "Earn from 100% to 210% profit thanks to the current geopolitical situation and rising oil prices",
  benefit2_title: "Security",
  benefit2_desc: "All transactions are protected, contracts are legally formalized, your investments are under reliable protection",
  benefit3_title: "Expert Support",
  benefit3_desc: "A team of 6 certified financial analysts with years of experience in the oil market",
  benefit4_title: "Quick Start",
  benefit4_desc: "Simple registration and contract activation process. Start earning today",
  benefit5_title: "Global Market",
  benefit5_desc: "Access to international Brent oil contracts at institutional level",
  benefit6_title: "Transparency",
  benefit6_desc: "Regular reports, analytics and full transparency of all operations and results",

  about_map_title: "STRAIT OF HORMUZ BLOCKED",
  about_map_sub: "of world oil",
  about_title: "CRISIS CREATES OPPORTUNITIES",
  about_p1: "The conflict in Iran has led to the blockade of the Strait of Hormuz — a critical route through which 20% of world oil supplies pass.",
  about_p2: "This caused a sharp rise in Brent oil prices, creating a unique opportunity for investors to realize significant profit through specialized oil contracts.",
  about_p3: "Geopolitical instability continues to affect the market and experts forecast further price increases in the coming months.",
  about_cta: "LEARN THE STRATEGY",

  contact_title: "READY TO START?",
  contact_subtitle: "Contact Nikolay Iliev and begin your investment journey today. Limited spots for new investors.",
  contact_website: "Official Website",
  contact_hours: "Working Hours",
  contact_hours_weekdays: "Monday – Friday: 9:00 – 18:00",
  contact_hours_saturday: "Saturday: 10:00 – 14:00",
  contact_security: "Security & Trust",
  contact_security_desc: "All transactions are protected and confidential",
  contact_team_title: "Choose your analyst",
  contact_team_sub: "6 licensed financial specialists",
  contact_team_desc: "Meet our team of experts and choose the analyst you want to work with. Each offers a personal approach and direct access to Brent oil contracts.",
  contact_btn: "CONTACT NIKOLAY ILIEV",
  contact_btn_sub: "Chief Financial Analyst with 15+ years of experience",
  contact_choose_analyst_btn: "CHOOSE YOUR ANALYST",
  contact_choose_analyst_sub: "6 licensed specialists — find your personal expert",
  contact_stat_analysts: "Analysts",
  contact_stat_clients: "Clients",
  contact_stat_yield: "Max. yield",

  footer_tagline: "Don't miss the opportunity to take advantage of the current market situation.",
  footer_nav: "NAVIGATION",
  footer_social: "CONNECT",
  footer_contact: "CONTACT",
  footer_contact_desc: "For more information and direct contact with Nikolay Iliev:",
  footer_rights: "© 2026 Brent Oil Investment. All rights reserved.",
  footer_terms: "Terms of Use",
  footer_privacy: "Privacy Policy",
  footer_disclaimer: "Investments in oil contracts carry risk. Past results do not guarantee future profit. Please invest responsibly.",
};

export default translation;
